module.exports = __webpack_public_path__ + "images/erp-nation-glad-title.1791972770245.png";